import { Flex, Heading } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FormikUploadFileInput } from "src/components/Inputs/Formik/FormikUploadFileInput";
import { FormikSwitchInput } from "src/components/Inputs/FormikSwitchInput";
import { InputControlWithMaxLength } from "src/components/Inputs/InputControlWithMaxLength";
import { LexicalControlWithMaxLength } from "src/components/Inputs/LexicalControlWithMaxLength";
import { AdminCard } from "src/components/Layout/AdminCard";
import { FormikType, MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from "./Formik";

export const BannerCard = () => {
  const formik = useFormikContext<FormikType>();
  return (
    <AdminCard
      title={
        <Heading as="h3" variant="admin">
          Banner
        </Heading>
      }
      description="An optional section to add a banner with an image and strong copy"
      actions={
        <Flex>
          <FormikSwitchInput
            checked={["enabled", ""]}
            unchecked={["disabled", ""]}
            name="banner.status"
          />
        </Flex>
      }
    >
      {formik.values.banner.status === "enabled" ? (
        <Flex direction="column" gap="4">
          <FormikUploadFileInput
            boxProps={{
              justifySelf: "flex-start",
            }}
            buttonLabel="Upload file"
            accept=".jpg, .jpeg, .png"
            multiple={false}
            name="banner.image"
            format="objectUrl"
            showPreview
            existingFileFieldName={"banner.imageUrl"}
            description="You can upload 1 file, supported formats: JPG/JPEG, PNG. Max 10MB."
          />
          <InputControlWithMaxLength
            label="Page title"
            id="banner.title"
            name="banner.title"
            maxLength={MAX_TITLE_LENGTH}
            inputProps={{ placeholder: "E.g.: Families" }}
          />
          {/* We don't support rich content for description yet, but I foresee that this request will come soon, so I'm preparing for it by using lexical with hidden toolbar for now. */}
          <LexicalControlWithMaxLength
            label="Page description"
            name="banner.description"
            maxLength={MAX_DESCRIPTION_LENGTH}
            plainFieldName="banner.plainDescription"
            format="html"
            height="5rem"
            settings={{
              hideToolbar: true,
              enableSmsStats: false,
              enableVariables: false,
              enableAutofocus: false,
              enableBlockFormat: false,
              enableElementFormat: false,
              enableTextFormat: false,
              enableImage: false,
              enableCode: false,
              enableHorizontalRule: false,
              enableLink: false,
            }}
          />
        </Flex>
      ) : null}
    </AdminCard>
  );
};
